module.exports = __webpack_public_path__ + "img/p_ajillo_corte.17f17875.jpg";